import { trackMatchingStatusHidesCandidates } from '@/constants/trackMatchStatus';

export interface CandidateRowVisibilityInput {
  hasUnlinkAction: boolean;
  effectiveRawDdexTrackId: unknown;
  matchStatusId: number | undefined;
  revealDoneMatches: boolean;
  hasPendingLinkSelection: boolean;
}

/**
 * When true, candidate match rows (raw DDEX / Spotify) are omitted from the flat table for this live track.
 * Live track row is always shown by the caller.
 */
export function shouldHideCandidateRowsForLiveTrack(input: CandidateRowVisibilityInput): boolean {
  const {
    hasUnlinkAction,
    effectiveRawDdexTrackId,
    matchStatusId,
    revealDoneMatches,
    hasPendingLinkSelection,
  } = input;

  return (
    !hasUnlinkAction &&
    !effectiveRawDdexTrackId &&
    trackMatchingStatusHidesCandidates(matchStatusId) &&
    !revealDoneMatches &&
    !hasPendingLinkSelection
  );
}
